import * as React from 'react';

export interface AdminTileProps {
  className?: string;
  fontSize?: string;
  icon?: string;
  iconWeight?: string;
  lines: string[];
  url?: string;
}

const AdminTile = ({
  url,
  icon,
  lines,
  iconWeight = 'fat',
  fontSize = '40px',
  className = 'btn btn-lg btn-block btn-primary admin-button',
}: AdminTileProps) => {
  const classes = url ? className : `${className} disabled`;
  return (
    <div className="admin-tile">
      <a href={url} className={classes}>
        <i className={`${icon} ${iconWeight}`} style={{ fontSize }} />
        {lines.map((line, index) => (
          <p style={{ marginBottom: 0 }} key={index}>
            {line}
          </p>
        ))}
      </a>
    </div>
  );
};

export default AdminTile;
